import { useState, useEffect, useRef } from "react";

import './listLectures.css';

import * as FetchDataUtils from '../lib/fetchDataUtils';
import * as LoggingUtils from '../lib/loggingUtils';

import DocumentExpanderContainer from "./DocumentExpanderContainer";

function ListAllDocuments({ 
    param_selectedDocumentsData,
  param_selectionModeFlag,
  param_selections,
  param_showOnlySelectedDocumentsFlag,
  param_searchText,
  param_fnOnChangedSelections,
  param_availableClassesList,
  param_DocumentToInsert,
  param_DocumentToUpdate,
  param_DocumentToDelete,
  param_FnInsertDocument,
  param_FnUpdateDocument,
  param_FnDeleteDocument,
 }) {
    const [documents, setDocuments] = useState([]);
  const [sortedClassesWithDocumentsInfo, setSortedClassesWithDocumentsInfo] = useState([]);
  const [selectionModeFlag, setSelectionModeFlag] = useState(false);
  const [selections, setSelections] = useState({});
  const [selectionsData, setSelectionsData] = useState({});
  const [showOnlySelectedDocumentsFlag, setShowOnlySelectedDocumentsFlag] = useState(false);
  const selectedDocumentsIdsRef = useRef([]);
  const [selectedDocumentsIds, setSelectedDocumentsIds] = useState([]);
  const [isSelectedFlag, setIsSelectedFlag] = useState(false);
  const [documentsBatch, setDocumentsBatch] = useState(10);

  async function fnDeleteDocument(doc) {
    if (window.confirm('Delete Document ?')) {
      const ret = await FetchDataUtils.deleteData("captures", doc, window.isEncrypted);
      if ('error' in ret) {
        LoggingUtils.log(ret);
        return;
      }
      setDocuments((documents) => documents.filter((d) => d.id !== doc.id));
      param_FnDeleteDocument(doc);
    }
  }

  function signalToParent_ChangedSelections(selectionArray) {
    param_fnOnChangedSelections(selectionArray);
  }

  function fnOnChildChangeSelectedFlag(documentId, isChildSelectedFlag) {
    if (isChildSelectedFlag && !selectedDocumentsIdsRef.current.includes(documentId)) {
      selectedDocumentsIdsRef.current.push(documentId);
    }
    if (!isChildSelectedFlag && selectedDocumentsIdsRef.current.includes(documentId)) {
      while (true) {
        const index = selectedDocumentsIdsRef.current.indexOf(documentId);
        if (index === -1) break;
        selectedDocumentsIdsRef.current.splice(index, 1);
      }
    }

    if (selectedDocumentsIdsRef.current.length === documents.length) {
      setIsSelectedFlag(true);
      setSelectedDocumentsIds(selectedDocumentsIdsRef.current);
      signalToParent_ChangedSelections([]);
      return;
    }

    if (selectedDocumentsIdsRef.current.length === 0) {
      setIsSelectedFlag(false);
      setSelectedDocumentsIds(selectedDocumentsIdsRef.current);
      signalToParent_ChangedSelections(null);
      return;
    }

    setSelectedDocumentsIds(selectedDocumentsIdsRef.current);
    setIsSelectedFlag(null);
    signalToParent_ChangedSelections(selectedDocumentsIdsRef.current);
  }

  const init = useRef(true);
  useEffect(() => {
    if (!init.current) {
      return;
    }
    init.current = false;

    async function serialExe() {
      const classesWithDocumentsInfo = await getClasses();
      const _sortedClassesWithDocumentsInfo = sortClassesWithDocumentsInfo(classesWithDocumentsInfo);
      setSortedClassesWithDocumentsInfo(_sortedClassesWithDocumentsInfo);

            const sortedDocuments = sortDocumentsInfo(_sortedClassesWithDocumentsInfo);
            setDocuments(sortedDocuments);
    }
    serialExe();
  }, []);

  useEffect(() => {
    if (sortedClassesWithDocumentsInfo == null) {
      return;
    }
    window.varSortedClassesWithDocumentsInfo = sortedClassesWithDocumentsInfo;
  }, [sortedClassesWithDocumentsInfo]);

  useEffect(() => {
    if (param_selectionModeFlag == null || param_selectionModeFlag == selectionModeFlag) {
      return;
    }

    if (param_selectionModeFlag) {
      setShowOnlySelectedDocumentsFlag(false);
    }

    setSelectionModeFlag(param_selectionModeFlag);
  }, [param_selectionModeFlag]);

  useEffect(() => {
    if (param_selections == null) return;

    const _selections = {};
    const _selectionsData = {};

    Object.keys(param_selections).map((className, idxClass) => {
      const selectedDocs = param_selections[className];

      if (Array.isArray(selectedDocs)) {
        _selections[className] = selectedDocs;
      } else {
        _selections[className] = [];
        Object.keys(selectedDocs).map((docId, idx) => {
          _selections[className].push(docId);
        });

        _selectionsData[className] = selectedDocs;
      }
    });

    setSelections(_selections);
    setSelectionsData(_selectionsData);
  }, [param_selections]);

  useEffect(() => {
    const _sortedClassesWithDocumentsInfo = sortOnlyClasses(sortedClassesWithDocumentsInfo);
    setSortedClassesWithDocumentsInfo([..._sortedClassesWithDocumentsInfo]);
  }, [selections]);

  useEffect(() => {
    if (param_showOnlySelectedDocumentsFlag == null) return;

    setShowOnlySelectedDocumentsFlag(param_showOnlySelectedDocumentsFlag);
  }, [param_showOnlySelectedDocumentsFlag]);

  function insertDocumentIntoClasses(param_DocumentToInsert) {
    const docClassName = !param_DocumentToInsert?.class ? '' : param_DocumentToInsert.class;
    let matchingClass = sortedClassesWithDocumentsInfo.find((c) => c.className === docClassName);
    if (typeof matchingClass === 'undefined') {
      matchingClass = {
        className: docClassName,
        items: [],
      };
      sortedClassesWithDocumentsInfo.push(matchingClass);
    }
    matchingClass.items.push(param_DocumentToInsert);
    const _sortedClassesWithDocumentsInfo = sortClassesWithDocumentsInfo(sortedClassesWithDocumentsInfo);
    setSortedClassesWithDocumentsInfo([..._sortedClassesWithDocumentsInfo]);
  }

  function updateDocumentInClasses(param_DocumentToUpdate) {
    const retObj = findDocumentById(sortedClassesWithDocumentsInfo, param_DocumentToUpdate.id);
    const originalClass = retObj.originalClass;
    const originalClassName = retObj.originalClassName;
    const originalDocumentIndex = retObj.originalDocumentIndex;
    const originalDocument = originalClass.items[originalDocumentIndex];
    const updatedDocument = Object.assign(originalDocument, param_DocumentToUpdate);
    if (!!param_DocumentToUpdate?.class && originalClassName !== param_DocumentToUpdate.class) {
      originalClass.items.splice(originalDocumentIndex, 1);
      insertDocumentIntoClasses(updatedDocument);
    }
    const _sortedClassesWithDocumentsInfo = sortClassesWithDocumentsInfo(sortedClassesWithDocumentsInfo);
    setSortedClassesWithDocumentsInfo([..._sortedClassesWithDocumentsInfo]);
  }

  function deleteDocumentInClasses(param_DocumentToDelete) {
    const retObj = findDocumentById(sortedClassesWithDocumentsInfo, param_DocumentToDelete.id);
    const originalClass = retObj.originalClass;
    const originalDocumentIndex = retObj.originalDocumentIndex;
    originalClass.items.splice(originalDocumentIndex, 1);
    const _sortedClassesWithDocumentsInfo = sortClassesWithDocumentsInfo(sortedClassesWithDocumentsInfo);
    setSortedClassesWithDocumentsInfo([..._sortedClassesWithDocumentsInfo]);
  }

  function findDocumentById(sortedClassesWithDocumentsInfo, documentId) {
    let originalDocument;
    let originalClass;
    let originalClassName;
    let originalDocumentIndex = -1;
    for (let i = 0; i < sortedClassesWithDocumentsInfo.length; i++) {
      const _class = sortedClassesWithDocumentsInfo[i];
      originalDocumentIndex = _class.items.findIndex((d) => d.id === documentId);
      if (originalDocumentIndex > -1) {
        originalClass = _class;
        originalDocument = _class.items[originalDocumentIndex];
        originalClassName = originalDocument.class;
        break;
      }
    }
    const retObj = {
      originalClass: originalClass,
      originalClassName: originalClassName,
      originalDocumentIndex: originalDocumentIndex,
    };
    return retObj;
  }

  const prevDocumentToInsertId = useRef(null);
  useEffect(() => {
    if (!param_DocumentToInsert) {
      return;
    }
    if (!!param_DocumentToInsert?.id && param_DocumentToInsert.id === prevDocumentToInsertId.current) {
      return;
    }
    insertDocumentIntoClasses(param_DocumentToInsert);
    prevDocumentToInsertId.current = param_DocumentToInsert.id;
  }, [param_DocumentToInsert]);

  const prevDocumentToUpdateId = useRef(null);
  useEffect(() => {
    if (!param_DocumentToUpdate) {
      return;
    }
    if (!!param_DocumentToUpdate?.id && param_DocumentToUpdate.id === prevDocumentToUpdateId.current) {
      return;
    }
    updateDocumentInClasses(param_DocumentToUpdate);
    prevDocumentToUpdateId.current = param_DocumentToUpdate.id;
  }, [param_DocumentToUpdate]);

  const prevDocumentToDeleteId = useRef(null);
  useEffect(() => {
    if (!param_DocumentToDelete) {
      return;
    }
    if (!!param_DocumentToDelete?.id && param_DocumentToDelete.id === prevDocumentToDeleteId.current) {
      return;
    }
    deleteDocumentInClasses(param_DocumentToDelete);
    prevDocumentToDeleteId.current = param_DocumentToDelete.id;
  }, [param_DocumentToDelete]);

  async function getClasses() {
    let classesWithDocumentsInfo = await FetchDataUtils.getData("captures/classes");
    if ('error' in classesWithDocumentsInfo) {
      LoggingUtils.log(classesWithDocumentsInfo);
      classesWithDocumentsInfo = null;
    }
    
    return classesWithDocumentsInfo;
  }

  function sortClassesWithDocumentsInfo(classesWithDocumentsInfo) {
    classesWithDocumentsInfo.map((c) => {
      const sortedDocuments = c.items.sort((a, b) => b.timestamp - a.timestamp);
      c.items = sortedDocuments;
      if (!!c.items?.length) {
        c.lastDocumentTimestamp = c.items[0].timestamp;
      } else {
        c.lastDocumentTimestamp = 0;
      }
    });
    const _sortedClassesWithDocumentsInfo = sortOnlyClasses(classesWithDocumentsInfo);
    return _sortedClassesWithDocumentsInfo;
  }

  function sortOnlyClasses(classesWithDocumentsInfo) {
    const _sortedClassesWithDocumentsInfo = classesWithDocumentsInfo.sort((a, b) => {
        let itemOrderFlag = b.lastDocumentTimestamp - a.lastDocumentTimestamp;
      if (selectionModeFlag) {
        if (b.className in selections && !(a.className in selections)) {
            itemOrderFlag = 1;
          }
        if (!(b.className in selections) && a.className in selections) {
            itemOrderFlag = -1;
          }
        }
        return itemOrderFlag;
    });
    return _sortedClassesWithDocumentsInfo;
  }

  function sortDocumentsInfo(classesWithDocumentsInfo) {
    const allDocuments = [];
    classesWithDocumentsInfo.forEach((c) => {
      allDocuments.push(...c.items);
    });
    return allDocuments.sort((a, b) => b.timestamp - a.timestamp);
  }

  function fnOnChangedSelections(className, selectionsInClass) {
    const _selections = { ...selections };
    if (selectionsInClass === null) {
      delete _selections[className];
    } else {
      _selections[className] = selectionsInClass;
    }
    setSelections(_selections);

    param_fnOnChangedSelections(_selections);
  }

  const loadMoreDocuments = () => {
    setDocumentsBatch((prevBatch) => prevBatch + 10);
  };

  return (
    <>
      {documents.slice(0, documentsBatch).map((doc, idx) => (
            <DocumentExpanderContainer 
              key={doc.id}
              param_selectionModeFlag={selectionModeFlag}
              param_isParentSelectedFlag={isSelectedFlag}
              param_isSelectedFlag={selectedDocumentsIds.includes(doc.id)}
              param_selectedDocumentData={param_selectedDocumentsData != null ? param_selectedDocumentsData[doc.id] : null}
              param_searchText={param_searchText}
              param_showOnlySelectedDocumentsFlag={param_showOnlySelectedDocumentsFlag}
              param_fnOnChildChangeSelectedFlag={(isChildSelectedFlag) => {
                fnOnChildChangeSelectedFlag(doc.id, isChildSelectedFlag);
              }}
              param_oneCapture={doc}
              param_availableClassesList={param_availableClassesList}
              param_FnInsertDocument={param_FnInsertDocument}
              param_FnUpdateDocument={param_FnUpdateDocument}
              param_FnDeleteDocument={fnDeleteDocument}
            />
      ))}

      {documentsBatch < documents.length && (
        <div className="load-more" onClick={loadMoreDocuments}>
          Load More
        </div>
      )}
    </>
  );  
}

export default ListAllDocuments;
